import { getRuntimeConfig } from "@/lib/runtime-config";

/**
 * The local bypass: `VITE_DEV_AUTH=1` in a DEV build sends `x-user-sub`
 * headers the local backend trusts under ALLOW_DEV_AUTH_HEADERS=1.
 * Double-gated on `import.meta.env.DEV` so it cannot survive a production
 * build.
 */
export const DEV_AUTH =
  import.meta.env.DEV && import.meta.env.VITE_DEV_AUTH === "1";
export const DEV_USER_SUB = "00000000-0000-4000-8000-0000000000d1";
export const DEV_USER_EMAIL = "dev@weply.local";

export function apiUrl(): string {
  return getRuntimeConfig().apiUrl.replace(/\/$/, "");
}

export function isAuthConfigured(): boolean {
  const { cognito } = getRuntimeConfig();
  return (
    DEV_AUTH || (cognito.userPoolId !== "" && cognito.userPoolClientId !== "")
  );
}

export function amplifyConfig() {
  const { cognito } = getRuntimeConfig();
  return {
    Auth: {
      Cognito: {
        userPoolId: cognito.userPoolId,
        userPoolClientId: cognito.userPoolClientId,
        loginWith: { email: true as const },
        signUpVerificationMethod: "code" as const,
      },
    },
  };
}
